import CheckoutData from "../../../entities/checkout/checkout-data/CheckoutData";
import { IOrderSteps } from "../../../entities/manhattan/order/types";
import { IManhattanFactory } from "../../manhattan/types";

export const CheckoutDataFactory: IManhattanFactory = class CheckoutDataFactory {

  static create(steps: IOrderSteps) {
    return new CheckoutData(
      steps
    );
  }

};
